import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
    postApiWithAuthorization,
    getApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

export const GetOrderTrackingDetails = async (UserID, OrderID, Type) => {
    const url = `${BaseUrl}/BookingTrack/GetOrderTrackingDetails?UserID=${UserID}&OrderID=${OrderID}&Type=${Type}`;
    const res = await getApiWithAuthorization(url);

    return res;
};

